import {
  Building2,
  CheckSquare,
  Clock3,
  FolderKanban,
  Gauge,
  Ticket,
  Timer,
  TrendingUp,
} from 'lucide-react'
import { GestorDashboardMetricCard } from '@/components/Gestores/GestorDashboardWidgets'
import { formatEffortMinutes } from '@/components/Gestores/gestorDashboardFormat'
import type { GestorDashboardOverview, GestorDashboardSummary } from '@/components/Gestores/gestorDashboardTypes'

function SectionHeading({ title, description }: { title: string; description?: string }) {
  return (
    <div className='mb-3'>
      <h3 className='text-sm font-semibold text-text-primary'>{title}</h3>
      {description ? <p className='mt-0.5 text-xs text-text-muted'>{description}</p> : null}
    </div>
  )
}

type Props = {
  overview: GestorDashboardOverview
  summary: GestorDashboardSummary
}

export function GestorDashboardOverviewKpis({ overview, summary }: Props) {
  return (
    <div className='space-y-6'>
      <section>
        <SectionHeading
          title='Indicadores principais'
          description='Volume de execução e esforço no período selecionado.'
        />
        <div className='grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4'>
          <GestorDashboardMetricCard
            label='Tarefas executadas'
            value={String(overview.executedTasks)}
            icon={<CheckSquare size={16} />}
          />
          <GestorDashboardMetricCard
            label='Tempo gasto'
            value={formatEffortMinutes(summary.totalEffortMinutes)}
            icon={<Clock3 size={16} />}
          />
          <GestorDashboardMetricCard
            label='Horas produtivas'
            value={formatEffortMinutes(summary.productiveEffortMinutes)}
            tone='success'
            icon={<Timer size={16} />}
          />
          <GestorDashboardMetricCard
            label='Esforço médio'
            value={formatEffortMinutes(overview.averageEffortMinutes)}
            icon={<Gauge size={16} />}
          />
        </div>
      </section>

      <section>
        <SectionHeading
          title='Cobertura e demanda'
          description='Clientes, projetos e tickets monitorados no período.'
        />
        <div className='grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4'>
          <GestorDashboardMetricCard
            label='Contas atendidas'
            value={String(summary.workspaceCount)}
            icon={<Building2 size={16} />}
            compact
          />
          <GestorDashboardMetricCard
            label='Projetos atendidos'
            value={String(overview.projectsServed)}
            icon={<FolderKanban size={16} />}
            compact
          />
          <GestorDashboardMetricCard
            label='Tickets abertos'
            value={String(overview.openTickets)}
            tone='danger'
            icon={<Ticket size={16} />}
            compact
          />
          <GestorDashboardMetricCard
            label='Média tarefas/dia'
            value={String(overview.avgDailyTasks)}
            icon={<TrendingUp size={16} />}
            compact
          />
        </div>
      </section>
    </div>
  )
}
